export const ISetProfileUseCaseType = Symbol('ISetProfileUseCase');
